import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { A11y, Autoplay, Navigation, Pagination } from 'swiper'
import 'swiper/css'
import desktopPhoto from '../img/hero-bg.jpg'
import mobilePhoto from '../img/header_bg_mobile.jpeg'
import mobileBannerPhoto from '../img/Olimp_Sredi-bogov_Banner-sait_SVG_mob.webp'
import bannerPhoto from '../img/Olimp_Sredi-bogov_Banner-sait_SVG.webp'
import mobileRassrochkaPhoto from '../img/rassrochka_Olimp_mob.webp'
import rassrochkaPhoto from '../img/rassrochka_Olimp_PC.webp'
// Добавляйте новые фото сюда. mobile — необязательное фото для телефона.
// content — необязательная JSX-разметка поверх фото только этого слайда.
const headerSlides = [
    {
        desktop: desktopPhoto,
        mobile: mobilePhoto,
        alt: 'ЖК Олимп в Георгиевске',
        content: (
            <>
                <h1>
                    {/* &nbsp; - Мягкий перенос чтобы избежать висячего слова */}
                    ЖК ОЛИМП <br className='br_first' />Квартиры в&nbsp;Георгиевске <span className='whitespace-nowrap'>от 4,1 млн руб</span>
                </h1>
                <div className="head_inf">
                    0% рассрочка от застройщика
                </div>
                <div className="head_inf" style={{ marginTop: "15px" }}>
                    Скидка участникам СВО до&nbsp;4000 руб/кв.м.
                </div>
                <div className="header_button">
                    <a className="btn_main" href="#" onClick={(e) => { e.preventDefault(); Marquiz.showModal('66e2e565518bf90026c50892') }}>Получить подборку квартир</a>
                </div>
            </>
        ),
    },
    { desktop: bannerPhoto, mobile: mobileBannerPhoto, alt: 'ЖК Олимп в Георгиевске' },
    { desktop: rassrochkaPhoto, mobile: mobileRassrochkaPhoto, alt: 'ЖК Олимп в Георгиевске' },
]

export const Header = () => {
    return (<React.Fragment>
        <div className="header plr">
            <Swiper
                className="header_gallery"
                modules={[A11y, Autoplay, Navigation, Pagination]}
                slidesPerView={1}
                speed={600}
                loop={headerSlides.length > 1}
                navigation={{
                    prevEl: '.header_gallery .header_gallery_prev',
                    nextEl: '.header_gallery .header_gallery_next',
                }}
                autoplay={headerSlides.length > 1 ? { delay: 5000, disableOnInteraction: false } : false}
                pagination={headerSlides.length > 1 ? { clickable: true } : false}
                a11y={{
                    prevSlideMessage: 'Предыдущее фото',
                    nextSlideMessage: 'Следующее фото',
                    paginationBulletMessage: 'Перейти к фото {{index}}',
                }}
                aria-label="Фотографии ЖК Олимп"
            >
                {headerSlides.map((slide, index) => (
                    <SwiperSlide key={slide.desktop}>
                        <picture className="header_slide_photo">
                            {slide.mobile && <source media="(max-width: 660px)" srcSet={slide.mobile} />}
                            <img src={slide.desktop} alt={slide.alt || ''} loading={index === 0 ? 'eager' : 'lazy'} />
                        </picture>
                        {slide.content && <div className="header_inner">{slide.content}</div>}
                    </SwiperSlide>
                ))}
                <button type="button" slot="container-end" className="header_gallery_arrow header_gallery_prev" aria-label="Предыдущее фото">
                    <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 5-7 7 7 7" /></svg>
                </button>
                <button type="button" slot="container-end" className="header_gallery_arrow header_gallery_next" aria-label="Следующее фото">
                    <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 5 7 7-7 7" /></svg>
                </button>
            </Swiper>

        </div>
    </React.Fragment>
    )
}

export default Header
